import { TemplatePage } from './types';
import { TEMPLATES_AMOUNT } from '@anm/constants/templates_amount';

const allTemplatesPage: TemplatePage = {
  header: {
    color: '#AFEDF8',
    icon: 'images/video-templates/main.jpg',
    title: 'Free Video Templates',
    title_meta: `${TEMPLATES_AMOUNT}+ Customizable Free Video Templates`,
    description_meta: `Create eye-pleasing and engaging video content with these ${TEMPLATES_AMOUNT}+ customizable free video templates.`,
    description:
      `Create eye-pleasing and engaging video content with ${TEMPLATES_AMOUNT}+ free video templates. Curated by Wave.video’s ` +
      'team of professional designers, these customizable free video templates will take your video marketing to ' +
      'the next level with less effort.'
  },
  footer: {
    category: '',
    description:
      'With extensive collection of easy-to-edit and free video templates, you won’t need to spend a ' +
      'fortune on video production. Just select a template that you prefer and effortlessly customize it to your ' +
      'taste. Then, you can download the video, share it directly on social media, or embed it on your website.'
  },
  content: [
    {
      type: 'templates',
      title: 'All templates',
      search: {}
    }
  ]
};

export default allTemplatesPage;
